
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"68","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71d3b9","d":"M33.937 12.44l17.464 8.438 4.314 18.96-12.086 15.204H24.246L12.16 39.838l4.313-18.96z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M24.737 18.135l16-.08 10.038 12.5-3.482 15.668-14.381 7.037-14.45-6.892-3.639-15.632z"}}),_c('g',[_c('path',{attrs:{"fill":"#fff","d":"M38 42a1 1 0 01.117 1.993L38 44h-5a1 1 0 01-.117-1.993L33 42zm3-4a1 1 0 01.117 1.993L41 40h-8a1 1 0 01-.117-1.993L33 38zm-3-4a1 1 0 01.117 1.993L38 36h-5a1 1 0 01-.117-1.993L33 34zm3-4a1 1 0 01.117 1.993L41 32h-8a1 1 0 01-.117-1.993L33 30zm0-4a1 1 0 01.117 1.993L41 28H25a1 1 0 01-.117-1.993L25 26zm-13 6h-2v2h2v-2m0-2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2zm0 10h-2v2h2v-2m0-2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2z"}})])])
          )
        }
      }
    